import { useContext } from './Context'
import { Template } from '../../../Template'
import React from 'react'
import { QueryTemplateInputValueWithFields } from './QueryTemplateInputValueWithFields'
import { QueryTemplateDisplayValue } from '../../../Template/TemplateValue/Query/Display'

export const ModalContent = () => {
  const { category, setActiveTemplate, onFilter } = useContext()

  const templateComponents = {
    TemplateInputValue: QueryTemplateInputValueWithFields,
    TemplateDisplayValue: QueryTemplateDisplayValue,
  }

  return <Template components={templateComponents} onChange={setActiveTemplate} height={50} category={category} onFilter={onFilter} />
}
